<template>
  <div :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <ul>
      <li :class="{active: $route.name === 'dashboard'}" @click="clickHandler('/dashboard')">Data Warga</li>
      <li :class="{active: $route.name === 'profile'}" @click="clickHandler('/profile')">Profile</li>
      <li v-if="$store.state.user.roleId >= 3 && $store.state.user.job === 'Pemerintah'" :class="{active: $route.name === 'map'}" @click="clickHandler('/map')">Map</li>
      <!-- <li v-if="$store.state.user.roleId >= 3 && $store.state.user.job === 'Pemerintah'" :class="{active: $route.name === 'letter'}" @click="clickHandler('/letter')">Surat</li> -->
      <li v-if="$store.state.user.roleId >= 3 && $store.state.user.job === 'Pemerintah'" :class="{active: $route.name === 'letter-search'}" @click="clickHandler('/letter-search')">Cari Surat</li>
      <li v-if="$store.state.user.roleId === 5 || $store.state.user.roleId === 13" :class="{active: $route.name === 'new-account'}" @click="clickHandler('/new-account')">New Account</li>
      <li v-if="$store.state.user.roleId === 5 || $store.state.user.roleId === 13" :class="{active: $route.name === 'change-role'}" @click="clickHandler('/change-role')">Change Role</li>
    </ul>
  </div>
</template>
<script>
 export default {
  methods: {
    clickHandler(route) {
      this.$router.push(route)
    }
  }
 }
</script>

<style scoped>
  li {
    margin-top: 10px;
    font-size: 1.3em;
    text-align: center;
    padding: 10px;
    cursor: pointer;
  }
  div {
    border-right: solid 5px #FFF;
    border-top: solid 5px #fff;
    height: calc(100% - 5px)
  }
  .pemerintah .active {
    background: #7faf8f
  }

  /* Color division */
  .pemerintah li {
    background: #077233;
  }

  .pemerintah {
    background: #003D19;
  }
  .ems {
    background: rgb(90, 1, 1);
  }
  .ems li {
    background: rgb(141, 2, 2)
  }
  .ems .active {
    background: rgb(195, 74, 74);
  }
</style>